import { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'
import AuthLayout from '@/components/layouts/AuthLayout'
import MainLayout from '@/components/layouts/MainLayout'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import ErrorBoundary from '@/components/common/ErrorBoundary'

// Page imports
import LoginPage from '@/pages/auth/LoginPage'
import SignUpPage from '@/pages/auth/SignUpPage'
import DashboardPage from '@/pages/DashboardPage'
import AlertsPage from '@/pages/AlertsPage'
import WorkOrdersPage from '@/pages/WorkOrdersPage'
import EquipmentPage from '@/pages/EquipmentPage'
import AnalyticsPage from '@/pages/AnalyticsPage'
import SettingsPage from '@/pages/SettingsPage'
import ProfilePage from '@/pages/ProfilePage'
import PropertiesPage from '@/pages/properties/PropertiesPage'
import UsersPage from '@/pages/users/UsersPage'
import NotFoundPage from '@/pages/NotFoundPage'

// WebSocket hook for real-time updates
import useWebSocket from '@/hooks/useWebSocket'

function App() {
  const { isSignedIn } = useAuth()
  const location = useLocation()

  // Initialize WebSocket connection for authenticated users
  useWebSocket()

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Auth routes */}
          <Route
            path="/login"
            element={
              isSignedIn ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AuthLayout>
                  <LoginPage />
                </AuthLayout>
              )
            }
          />
          <Route
            path="/sign-up"
            element={
              isSignedIn ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AuthLayout>
                  <SignUpPage />
                </AuthLayout>
              )
            }
          />

          {/* Protected app routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/alerts" element={<AlertsPage />} />
                    <Route path="/work-orders" element={<WorkOrdersPage />} />
                    <Route path="/equipment" element={<EquipmentPage />} />
                    <Route path="/properties" element={<PropertiesPage />} />
                    <Route path="/users" element={<UsersPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App